export default {
  content: `
     <div class="protocol-container">
    <h2 class="text-center">协议生效时间：2025年06月29日</h2>

    <p>欢迎您使用金声玉亮系列会员服务！</p>
    <p>
      为使用金声玉亮系列会员服务，请您仔细阅读、理解并遵守《金声玉亮系列会员服务协议》（以下简称“本协议”）。
    </p>

    <p>
      本协议由您与上海亿熵智能科技有限公司、北京未来级数科技有限公司及其关联公司（以下简称“金声玉亮”）共同缔结，对双方具有法律效力。请仔细阅读以下全部内容，特别是以<strong>黑体加粗或其他合理方式提示您注意的条款</strong>，该等条款可能与您的权益存在重大利害关系，包括但不限于金声玉亮责任、您享有的权利、争议解决方式及司法管辖条款等，请您留意重点阅读。如果您认为本协议中加粗条款可能导致您的部分或全部权利或利益受损，请您在确认同意本协议之前或在使用本服务之前务必再次阅读前述条款，并在您自愿接受该等条款的前提下使用本服务。
    </p>

    <p>
      如果您不同意本协议的任一或全部条款内容，请不要以确认的形式（包括但不限于：点击、进入购买程序等）进行下一步操作或使用本协议项下服务。当您确认接受本协议或开始使用本协议项下金声玉亮服务时，即表示您与金声玉亮已达成协议关系，并自愿接受并遵守本协议项下的全部约定。
    </p>
    <p><strong>若您是未成年人，请您在法定监护人的陪同下阅读并确认本协议条款。</strong></p>

    <h3>一、服务说明</h3>
    <ol>
      <li>
        金声玉亮系列会员包括：<br />
        <strong>金声玉亮VIP会员：</strong> 是指完成成为金声玉亮VIP会员的所有程序，且在遵守本协议的前提下，在会员时长有效期内享受金声玉亮提供的VIP会员服务的自然人，本协议项下金声玉亮VIP会员又称“您”或“会员”。<br />
        金声玉亮VIP会员可在手机端、电脑端、Pad端使用。
      </li>
      <li>
        金声玉亮系列会员服务：是由金声玉亮向您提供的VIP会员的专享权益，会员服务/权益内容说明请您查看本协议第三条，具体权益内容以金声玉亮“服务器兑换详情”页面中描述为准。
      </li>
      <li>
        《金声玉亮系列会员服务协议》：是《金声玉亮用户服务协议》《金声玉亮隐私政策》的补充协议，是其不可分割的一部分，与其具有同等法律效力，本协议如与前述协议发生冲突的，以本协议为准。
      </li>
      <li>
        金声玉亮系列会员服务规则：是金声玉亮在金声玉亮平台已经或未来不时发布的与VIP会员服务相关的协议、VIP会员守则、活动规则、使用规则、公告、提示、通知及在线FAQ等内容，金声玉亮会通过系统提示和/或信息推送和／或后台公告等形式发布，上述内容一经正式发布即生效，为本协议不可分割的组成部分。
      </li>
    </ol>

    <h3>二、会员账号开通、管理及使用、注销</h3>
    <h4>（一）会员账号开通</h4>
    <ol>
      <li>您可以通过支付会员服务费或通过营销活动等金声玉亮认可的途径成为金声玉亮系列会员，当您完成成为金声玉亮会员的所有程序，您通过登录您的金声玉亮会员账号方可享受金声玉亮相应会员服务。</li>
      <li>您可以通过登录金声玉亮VIP会员中心免费查询您的账号信息详情，包括已开通的服务内容、服务期限。您可以在“我的”-“算力值”-“充值记录”查询消费金额、交易状态信息。</li>
      <li>
        <strong>请您特别注意：</strong>
        <ol type="a">
          <li>
            如您在金声玉亮上看到金声玉亮VIP会员服务以外的其他付费服务，并且想了解相关服务，请您仔细阅读相关服务页面的规则或服务协议，并请关注服务提供方；如您需要开通该类服务，将由对应服务提供方向您提供服务并收取费用，后续对于该服务有任何问题，请您联系服务提供方。
          </li>
          <li>
            如您选择订购联合会员服务或因购买金声玉亮系列会员服务而获赠第三方会员服务的，金声玉亮仅提供金声玉亮系列会员服务，不对第三方的会员服务负责。第三方会员服务的权益、使用、收费规则等问题由第三方执行和解释。
          </li>
        </ol>
      </li>
    </ol>

    <h4>（二）账号管理及使用</h4>
    <ol>
      <li>
        <strong>账号管理</strong>
        <ol type="a">
          <li>您应正确使用及妥善保管、维护您的金声玉亮VIP会员账号及密码，如发生泄漏、遗失、被盗等行为，而该等行为并非金声玉亮法定过错导致，损失将由您自行承担。</li>
          <li>如果您发现有人未经授权使用了您的账号或您的账号存在其他异常情况导致无法正常登录使用的，则您需要按照金声玉亮官方公布的账号找回流程进行账号找回。在找回过程中，金声玉亮可能会要求您提供相应信息及/或证明资料，请确保您所提供的内容真实有效，否则将可能无法通过金声玉亮的验证而导致找回失败。</li>
          <li>为保护您的账号安全，防止账号被盗等情况发生，金声玉亮可定期或不定期采用不同的方式对您账号的使用安全进行检查、验证，包括但不限于主动联系您进行身份验证、短消息验证、邮箱认证等。如您无法完成验证或无正当理由拒绝验证的，金声玉亮可合理怀疑您的账号出现异常或被盗，因而中止向该账号提供服务或采取进一步措施。</li>
        </ol>
      </li>
      <li>
        <strong>账号使用</strong>
        <ol type="a">
          <li>
            <strong>合法获取及使用</strong>
            <ol type="i">
              <li>金声玉亮系列会员服务，仅限于您在金声玉亮内或上述可用终端及应用使用，任何以破解、转译、转录等非法手段将金声玉亮服务与金声玉亮平台或上述可用终端及应用分离的行为，均不属于本协议中约定的金声玉亮系列会员服务，金声玉亮保留追究侵权行为人法律责任及索赔的权利。</li>
              <li>任何以盗窃、利用系统漏洞（包括但不限于机器人软件、蜘蛛软件、爬虫软件、刷屏软件等）、通过任何非金声玉亮官方或授权途径获得的金声玉亮系列会员服务（包括但不限于购买、租用、借用、分享、受让等方式获得）、恶意利用或破坏金声玉亮系列会员活动获得的会员服务，均不获本协议项下的相关保护，金声玉亮有权取消及/或不予提供会员服务，所有产生的损失及责任由侵权行为人自行承担。</li>
              <li>除经金声玉亮授权代理商或者与第三方平台进行联合会员的销售外，金声玉亮从未授权其他任何第三方销售、转让金声玉亮系列会员资格。任何未经金声玉亮明示授权而销售、转让金声玉亮系列会员资格的行为属于非法销售、非法转让，金声玉亮有权追究其法律责任。</li>
              <li>您开通、使用金声玉亮系列会员服务及/或参加相关活动时，应通过金声玉亮官方公布/授权的方式进行。通过其他渠道、途径、方式非法获取的金声玉亮系列会员服务（包括且不限于账号、会员权益等）或参加活动获取福利（包括但不限于获得实体/虚拟礼品、会员权益等），均不获本协议项下的相关保护。且一经发现为非法获取，金声玉亮有权立即就相关服务做出删除、取消、清零等处理，或采取其他如中止或终止对该用户提供服务等账号管理措施，所有因此产生的损失及责任由侵权行为人自行承担。</li>
              <li>您参加会员活动时，应按照活动规则、以合法且不损害活动举办方利益的方式进行。如您利用系统漏洞、规则设置缺陷、系统设置错误、滥用会员身份等参加活动并获取相关福利的，均不获本协议项下的相关保护，且优有权采取相关措施进行处理，所有因此产生的损失及责任由侵权行为人自行行承担。</li>
              <li>金声玉亮系列会员服务，是在您遵守本协议及相关法律、法规、政策、公序良俗等的前提下，金声玉亮给予您一项个人的、不可转让的、非商业用途的、可撤销的、有期限及非排他性的许可。您仅可出于个人、非商业的目的使用金声玉亮系列会员服务。</li>
              <li>您理解并同意，您不得将享有金声玉亮VIP会员服务的账号以任何方式提供给他人使用，包括但不限于不得以转让、出租、借用、分享、出售等方式提供给他人作包括但不限于直播、录制、观看、上传、参加活动等使用。因上述行为导致账号遗失、泄露、被篡改、被盗等损失的，或因多终端登录、异地登录等情况触发金声玉亮安全风控导致账号异常、账号被封的损失的，亦应当由您自行承担，且金声玉亮有权根据您的违约情况决定是否中止或终止为您提供服务。</li>
            </ol>
          </li>
          <li>
            <strong>权利归属</strong><br />
            您理解并同意：您拥有合法获得的金声玉亮系列会员账号下金声玉亮系列会员服务、虚拟社区商品等服务和产品的使用权，上述服务和产品及其衍生物的所有权及知识产权均归金声玉亮所有，但是经合法渠道取得的实体产品所有权或金声玉亮另有公告说明的除外。
          </li>
          <li>
            <strong>登录限制</strong>
            <ol type="i">
              <li>金声玉亮账号根据不同的会员类型可在不同设备终端上进行使用，设备终端包括但不限于手机端、Pad端、网页端、电脑客户端、电视端、车载端等（包括小程序、未来业务发展增加端）以及上述终端相应的网页端（如有）。各具体会员适用的设备终端以具体类型会员的权益介绍页面说明为准。</li>
              <li>同一金声玉亮VIP会员账号最多同时登录的终端上限为1个，其中分设备限制包括但不限于：手机端App 1个、Pad端App 1个、网页端1个、电脑客户端1个、车载端1个等。</li>
              <li>如您超出上述使用限制，您应当立即：1）关闭其他设备上的登录；2）及时修改密码并重新登录。您可以在产品中查阅、管理您的金声玉亮账号的设备终端登录情况。</li>
            </ol>
          </li>
          <li>
            <strong>登出</strong><br />
            若您需要退出登录，可以在“我的”中点击退出登录。在您下次选择登录时，您可以继续查看之前留下的数据信息。
          </li>
          <li>
            <strong>游客模式</strong>
            <ol type="i">
              <li>因苹果应用商店渠道允许非注册用户通过游客方式购买金声玉亮系列会员服务，会员服务将会绑定您购买会员时所用的设备，金声玉亮系列会员服务也将仅可在绑定设备上使用，且部分会员权益可能会因为您使用游客模式而无法享受（如活动参与、会员时长转赠等）。若您设备丢失、损坏、进行系统升级、还原、清空或其他类似行为的，将会导致您无法继续使用绑定于此设备的会员权益，由此造成的您的损失，您应当自行承担。</li>
              <li>金声玉亮在此建议您按照页面操作指引绑定您的金声玉亮注册账号，以便可在您所拥有的其他设备上使用会员权益及更好地享受金声玉亮所提供给您的会员权益。</li>
            </ol>
          </li>
        </ol>
      </li>
    </ol>

    <h4>（三）账号注销</h4>
    <p>
      <ol>
      <li>除金声玉亮按照法律法规规定及本协议约定注销会员账号外，您可以通过在线申请注销或联系金声玉亮的客服或通过其他金声玉亮公示的方式注销会员账号。账号一旦注销，您将无法继续使用金声玉亮系列会员服务。且您曾通过该账号使用的金声玉亮或/及其关联公司的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理；除法律法规另有规定，您也无法再检索、访问、获取、继续使用和找回，也无权要求金声玉亮找回。账号注销流程、注销的前提条件、注销的后果承担及注意事项等请您详见《金声玉亮账号注销协议》</li>
      </ol>
    </p>

    <h3>三、金声玉亮系列会员权益及服务期限、收费</h3>
    <h4>（一）权益内容</h4>
    <ol>
      <li>金声玉亮VIP会员权益，即金声玉亮为VIP会员提供的内容、身份、福利方面的优惠及增值服务，包括但不限于标有VIP标识、会员福利等，具体以金声玉亮VIP特权页面的说明或者实际提供为准，本协议项下的会员权益名称与页面的说明不一致的，不影响您所实际享受的会员权益的内容。</li>
      <li>金声玉亮系列会员分为不同等级，不同等级之间的会员权益亦可能存在差异，您在会员服务项下可享受的具体会员权益以金声玉亮的页面说明或金声玉亮实际提供为准。</li>
      <li>金声玉亮可能会根据法律法规及政策变更、版权状态变化、自身运营策略对提供服务作出部分调整。</li>
      <li>您通过金声玉亮指定渠道开通本服务后，可能会由于您使用的软件版本、设备、操作系统等的不同以及其他第三方原因导致您实际可使用的具体服务有一定差别，由此可能给您带来的不便，您表示理解。金声玉亮建议您可以通过升级应用程序或者操作系统版本、更换使用设备等方式来尝试解决，或者直接通过本协议提供的方式与金声玉亮联系解决。金声玉亮在此特别提醒您，部分会员权益需要满足一定软件版本设备及/或操作系统要求，因此，金声玉亮建议您为了完整的体验全部权益请您及时升级应用程序或操作系统版本、或更换使用设备以顺利的享受会员权益。</li>
    </ol>

    <h4>（二）服务期限</h4>
    <ol>
      <li>金声玉亮系列会员服务的服务期限以会员自行选择并支付相应会员费用的期限为准，具体期限您也可以登录金声玉亮-我的查看或者本服务的相应页面查询。该期限不因您未使用或中途暂停等情况而延长。当会员服务期限到期后，金声玉亮将停止继续向您提供会员服务。自动续费的会员服务在当前周期内的服务有效期到期前，您可以单方面停止自动续费，金声玉亮亦可以根据运营策略需要而单方面停止继续向您自动续费服务，会员服务期限自当前服务周期届满之日起终止。</li>
      <li>VIP会员标准时长：
        <br>月度会员，使用有效期为开通之时起31天；
        <br>季度会员，使用有效期为开通之时起93天；
        <br>年度会员，使用效期为开通之时起365天。
        <br>举例：如您在2023年3月1日10：30：31成功订购VIP月度会员，则会员有效期至2023年4月1日10：30：31终止。
      </li>
      <li>请您理解，由于互联网服务的特殊性，为向您提供优质服务，金声玉亮须不定时进行服务器的维修、调整、升级等，且在黑客攻击、计算机病毒侵入、监管机构政策通知等不可抗力事件发生后，金声玉亮须解决故障并处理相关侵权事宜，金声玉亮将尽可能降低该等情形对您的影响。</li>
    </ol>

    <h4>（三）收费</h4>
    <ol>
      <li>本服务是金声玉亮提供的收费服务，您须在按照本服务的收费标准支付相应费用后，方可使用本服务。此外，您也可通过金声玉亮认可的其他方式享有、使用本服务。</li>
      <li>您可通过金声玉亮实际支持的付费方式完成会员费用的支付，如银行卡支付、第三方支付等。请您注意，若您使用您的苹果账户或与您的会员账号绑定的通信账户进行支付，此付费方式为代收费运营商托收的付款方式，您通过此种付费方式付费可能存在一定的商业风险（如不法分子利用您账户或银行卡等有价卡等进行违法活动），该等风险可能会给您造成相应的经济损失，您应自行承担全部损失。</li>
      <li>金声玉亮可能会根据本服务的整体规划、版权采购价格的变化等，对系列会员服务收费标准(包括但不限于自动续费、额外付费等)、收费方式等进行调整（调整包含变更、取消、减少、增加相应内容），并在相关服务页面或以合理方式事先通知您。若您在购买和续费时，相关服务的价格发生了调整的，应以金声玉亮公示的现时有效的价格为准（但金声玉亮与您另有约定的情形除外）。</li>
      <li>金声玉亮系列会员服务系网络商品和虚拟商品，会员费用是您所购买的会员服务所对应的网络商品价格，而非预付款或者存款、定金、储蓄卡等性质。会员服务一经开通后不可退款。如因会员服务存在重大瑕疵导致您完全无法使用等金声玉亮违约情形、本协议另有约定、法律法规要求必须退款的或金声玉亮同意退款等除外。</li>
    </ol>
    <p style="font-weight:bold;">
      金声玉亮在此特别提醒您，您在购买会员服务（包括自动续费服务）之前应仔细核对账号信息、购买的服务内容、价格、服务期限等信息。
    </p>

    <h4>（四）其他会员的权利及限制</h4>
    <ol>
      <li>您在使用金声玉亮系列会员服务过程中，应遵守宪法法律，包括但不限于《中华人民共和国著作权法》、《中华人民共和国网络安全法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《信息网络传播权保护条例》等有关计算机及互联网规定的法律、法规；应遵守公共秩序，尊重社会公德；不得危害网络安全；不得利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及侵害他人名誉、隐私、知识产权和其他合法权益等活动。在任何情况下，金声玉亮一旦合理地认为用户存在上述行为的，出于维护网络安全、公共秩序等必要性，可以在任何时候，不经事先通知，终止向该用户提供服务。</li>
      <li>您理解并同意，由于您使用的设备终端的产品技术不同，金声玉亮VIP会员权益和福利可能在不同终端有所差异，具体请见金声玉亮的页面说明或该终端可以支持的服务说明。金声玉亮有权根据法律规定及政策变更、版权方要求、运营需求等进行VIP会员权益及特色会员服务内容的全部或部分调整（包括但不限于变更、取消、减少、增加服务内容等），就前述权益的调整，金声玉亮将在“VIP特权”说明页面、相应服务页面或以其他合理方式进行发布，并在发布后生效，我们建议请您仔细阅读。金声玉亮将尽力确保上述调整不会损害会员已有利益，如您对调整有异议，请您联系我们的客服。</li>
    </ol>

    <h3>四、个人信息保护</h3>
    <ol>
      <li>金声玉亮非常重视您个人信息的保护，在您使用金声玉亮提供的服务时，您同意金声玉亮按照在金声玉亮公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。金声玉亮希望通过隐私权政策向您清楚地介绍金声玉亮对您个人信息的处理方式，因此金声玉亮建议您完整地阅读隐私权政策，以帮助您更好地保护您的隐私权。更多关于个人信息处理和保护规则、用户对个人信息的控制权等内容，请查阅《金声玉亮隐私政策》。</li>
      <li>金声玉亮非常注重未成年人的保护。若用户未满18周岁，则为未成年人，应在其监护人监护、指导下阅读本协议和使用金声玉亮系列会员服务。</li>
      <li>监护人应指导子女上网应该注意的安全问题，防患于未然。若监护人同意未成年人使用金声玉亮提供的金声玉亮系列会员服务，必须以监护人名义申请消费，并对未成年人使用本会员服务进行正确引导、监督。未成年人行使和履行本协议项下的权利和义务即视为已获得了监护人的认可。</li>
      <li>金声玉亮提醒未成年人用户在使用金声玉亮系列会员服务时，要善于网上学习，认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活。</li>
    </ol>

    <h3>五、通知和送达</h3>
    <p>
      对于金声玉亮VIP会员服务所有的通知均可通过金声玉亮网页公告、站内消息、客户端推送、公众号通知、会员预留的电子邮件、手机短信或常规的信件传送等方式进行，该等通知于发送之日视为已送达用户。
      请您应确保预留的联系方式为正确及有效，并在变更后及时登录金声玉亮修改，如因您未提供正确的联系信息或未及时告知新的联系方式，导致无法及时收取通知，将由您自行承担由此产生的损失及法律后果。
    </p>

    <h3>六、服务的中止/终止及变更</h3>
    <ol>
      <li>本服务的中止或终止包含如下情况：
        <ol type="a">
          <li>您主动中止或终止，包括但不限于会员到期未进行续费等；</li>
          <li>因为您的违约或违规行为，金声玉亮主动中止或终止服务的；</li>
          <li>因国家或相关政府监管部门要求或发生不可抗力事件时，金声玉亮中止或终止服务的；</li>
          <li>其他根据法律法规应中止或终止服务的。</li>
        </ol>
      </li>
      <li>中止或终止服务后，金声玉亮有权利但无需确保您收到特别提示或通知。当您发现无法登录或享受服务时，可以咨询金声玉亮客服人员。</li>
      <li>中止或终止后的处理：
        <ol type="a">
          <li>除法律规定的责任外，金声玉亮对本服务的中止或终止对您和第三人不承担任何责任；</li>
          <li>除法律规定或本协议另有约定外，已收取的费用不予退还；</li>
          <li>在金声玉亮正在进行的交易，金声玉亮将根据情况合理判断，是否继续进行或终止相关交易，并视情况决定是否进行退费或扣除相关费用作为违约金。</li>
        </ol>
      </li>
      <li>对于本协议或规则可能发生的变更（包括但不限于本协议修改、服务细则调整、会员权益调整等），金声玉亮将根据本协议的约定相应通知您，请您仔细阅读并选择是否按照调整和/或变更后的本协议/服务细则/会员权益等继续选择本服务。如您同意上述调整和/或变更，您可以采用接受服务的形式进行下一步操作或继续使用本服务，以表明您已经接受上述调整和/或变更；如您不同意调整和/或变更，我们建议您立即停止使用本服务。如您对上述调整和/或变更有任何问题，可以咨询客服。</li>
    </ol>

    <h3>七、争议解决和法律适用</h3>
    <ol>
      <li>本协议条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，本协议条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。</li>
      <li>如就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可向被告所在地人民法院提起诉讼。</li>
    </ol>

    <h3>八、联系我们</h3>
    <p>
      如您对本协议或使用金声玉亮会员服务的过程中有任何问题（包括问题咨询、投诉等），金声玉亮专门为您提供了多种反馈通道，希望为您提供满意的解决方案：<br>
      (1)您可与金声玉亮在线客服联系或者在线提交意见反馈；<br>
      (2)您发送金声玉亮的客服邮件：<a href="mailto:service@ainvestcn.com">service@ainvestcn.com</a>与金声玉亮联系。<br>
      我们会在收到您的反馈后尽快向您答复。
    </p>

    <h3>九、其他</h3>
    <ol>
      <li>本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</li>
      <li>本协议的标题仅为方便及阅读而设，并不影响正文中任何条款的含义或解释。</li>
    </ol>
    <p style="text-align:right; margin-top:40px;">上海亿熵智能科技有限公司</p>
    `,
	riskContent:`<div data-v-371a9756="" class="content-html">感谢您选择金声玉亮量化技术服务。为了使您更好地了解相关业务的基础知识和相关风险，根据有关法律、法规的规定，金声玉亮特向您进行如下风险揭示，请您仔细阅读并签署：<br>
	1、本公司承诺提供专业技术服务，不承诺客户获取投资收益，也不与客户约定分享投资收益或分担投资损失。<br>
	2、本公司所有视频、文字图表、技术服务均仅代表机构或者个人观点，仅供辅助作用。投资者应当充分了解市场规则，做出使用决策并独立承担风险。<br>
	3、建议不要透支、借贷进入资本市场，不要用“必须的基本生活费用”来投入市场，只有用闲钱进行投资，心态才会相对稳定。<br>
	4、本公司提供的证券相关资讯具有针对性和时效性，不能在任何市场环境下长期有效。<br>
	5、客户应向本公司提供有效的联系方式和服务获取方式，如有变动须及时向本公司进行说明，如因客户自身原因或不可抗力因素导致未能及时获取本合同约定的相关技术服务，责任将由客户自行承担。<br>
	6、客户应保管好从本公司获取的登录本公司网络平台的账号及密码，不得私自接受本公司员工的个人咨询服务，否则由此导致的风险将由客户自行承担。<br>
	7、金声玉亮是以网络平台工具、软件工具、终端设备等为载体，向客户提供技术或者类似功能服务，您必须了解其实际功能、信息来源、固有缺陷和使用风险，由于您自身原因导致该网络平台工具、软件工具、终端设备等使用不当或受到病毒入侵、黑客攻击等不良影响的， 由此导致的风险将由您自行承担。<br>
	  7.1、金声玉亮必须借助于PC/手机终端、互联网络，接收数据及信息。<br>
	  7.2、金声玉亮存在因软硬件故障、互联网接入故障、服务器故障等原因导致软件无法接收数据的可能。<br>
	  7.3、金声玉亮需数据信息支持。<br>
	  7.4、金声玉亮不能完全准确的预测证券市场走势，我们提供的证券投资建议能为投资者提供一定的参考，但不能承诺投资收益，且具体决策须由投资者自行作出。<br>
	8、股市有风险，投资需谨慎。<br>
	
	本风险揭示书的揭示事项仅为列举性质，未能详尽列明投资者接受证券投资顾问服务所面临的全部风险和可能导致投资者投资损失的所有因素。<br>
	
	特别提示：请您在充分知晓并理解上述《风险提示书》的前提下，签署本风险揭示书。</div>`,
	payContent:`<div style="font-family: '微软雅黑', Arial, sans-serif; font-size: 15px; color: #222; line-height: 1.8;">
	  <h2 style="text-align: center;">大模型及算法备案信息公示</h2>
	  <p>亲爱的用户，欢迎您使用金声玉亮产品及服务！</p>
	  <p>金声玉亮产品及服务由上海亿熵智能科技有限公司、北京未来级数科技有限公司及其关联公司（以下简称“我们”或“金声玉亮”）共同所有和负责运营。</p>
	  <p>我们提供的生成式人工智能产品和服务以金声玉亮大语言模型为基础。金声玉亮大语言模型架构基于先进的 Transformer，这一架构以其强大的并行计算能力和灵活的序列建模能力，为模型处理复杂语言任务奠定了基础。在训练过程中，选用英伟达 A800 作为 GPU，训练框架采用 PyTorch，其动态计算图和丰富的库函数，为模型的开发和调试带来了极大的便利，也使得模型能够更好地适应不同的硬件环境和任务需求。</p>
	
	  <h3>金声玉亮模型及算法备案的公示信息如下：</h3>
	  <table border="1" cellspacing="0" cellpadding="8" style="border-collapse: collapse; width: 100%; margin: 12px 0;">
	    <thead style="background: #f5f5f5;">
	      <tr>
	        <th>备案类型</th>
	        <th>备案名称</th>
	        <th>备案号</th>
	        <th>公示链接</th>
	      </tr>
	    </thead>
	    <tbody>
	      <tr>
	        <td>生成式人工智能服务备案</td>
	        <td>金声玉亮</td>
	        <td>Shanghai-JinShengYuLiang-202503260042</td>
	        <td><a href="https://jswx.gov.cn/csj/sh/202504/t20250425_3562055.shtml" target="_blank">备案地址</a></td>
	      </tr>
	      <tr>
	        <td>深度合成服务算法备案</td>
	        <td>金声玉亮大模型算法</td>
	        <td>网信算备310104666296401240017号</td>
			<td>备案号 沪ICP备2024069186号-3</td>
	        <td><a href="https://www.cac.gov.cn/2024-08/05/c_1724541639039621.htm" target="_blank">备案地址</a></td>
	      </tr>
	    </tbody>
	  </table>
	  <h2 style="text-align: center;">软件许可及技术服务合同</h2>
	<p>甲方： 北京未来级数科技有限公司<br>乙方： 用户</p>
	<p>(在本合同中，乙方、甲方单独称 “一方”，合称 “双方”)</p>
	
	<p>鉴于：</p>
	<p>甲方作为专业的大数据供应、软件开发以及软件服务提供商，拥有软件[“软件”]的所有权利并有能力提供相应的数据库与数据服务[“数据服务”]，能够提供其所自主开发并拥有的软件许可升级、安装、调试、维护、增强和使用培训服务以及提供相应的数据。</p>
	<p>乙方因自身需要，同意按照本合同约定，向甲方定购使用该软件，并接收甲方加工、整理和传送的数据使用端口。</p>
	<p>以本合同的条款和条件为前提，甲方同意向乙方授予软件的许可，并向乙方提供其所定购的数据。为了维护甲乙双方的正当权益，根据相关法律法规，在平等自愿的基础上，经甲乙双方协商一致，特订立此合同，共同遵守。</p>
	
	<h3>定义</h3>
	<p>在本合同中，除非另有定义或上下文另有要求，下列术语有以下含义：</p>
	<ul>
	  <li>“软件”：指甲方提供给乙方的所有计算机程序以及该等程序的所有更新版本。</li>
	  <li>“数据服务”：指甲方整理加工并及时传送给乙方的所有数据以及数据的更新，其中也包括第三方的数据与数据传送服务。</li>
	  <li>“合同”：指本《软件许可及技术服务合同》及所有附件，这些附件为本合同不可分割的组成部分。</li>
	  <li>“机密信息”：双方标记为机密的各种商业秘密和机密信息，包括但不限于软件、文件、任何一方在履行本合同期间获得的涉及对方商业、未来产品或计划的任何信息或文件，以及甲方或乙方希望不要随意泄露或防止竞争性使用的信息，或者信息披露方指定为机密的信息。</li>
	  <li>“增强”：因软件的技术或需求缺陷而对原版本的更新与修改。</li>
	  <li>“故障”：软件整体或部分发生故障，不符合其技术规范。</li>
	  <li>“人民币”：指人民币，中国的法定货币。</li>
	</ul>
	
	<h3>软件许可升级及数据服务</h3>
	<ol>
	  <li><strong>定购：</strong>根据本合同的条款与条件，乙方向甲方定购《采购订单及补充协议》所列的产品和服务。</li>
	  <li><strong>授予软件许可：</strong>根据本合同的条款与条件，甲方在此同意授予并且乙方同意接受一份非独家性的软件使用许可，以便乙方在本合同约定期限内为其业务用途使用软件，并且接受软件的调试、维护、增强等服务内容。未经甲方事先书面同意，乙方不得将使用许可转移或授权给乙方之外的任何第三方。如果乙方未经甲方事先书面同意转移或授权给乙方之外的任何第三方使用，甲方有权立即解除本合同。</li>
	  <li><strong>授予数据服务：</strong>根据本合同的条款与条件，甲方在此同意授予并向乙方传送该软件所需要的非独家性的数据，以便乙方在本合同约定期限内为其业务用途使用。</li>
	  <li><strong>限制：</strong><br>
	    （1）未经甲方事先书面同意，乙方不得对软件的任何部分进行修改、翻译、反向工程、反编译、反汇编或基于此软件或文件制造派生产品；也不得删除此软件或文件上的任何所有权声明或标签。<br>
	    （2）乙方订购甲方软件的使用地域及网络出口均限于中国大陆地区内（港澳台、海外除外）。<br>
	    （3）乙方使用和利用甲方软件或数据不能损害甲方的利益和业务模式，如甲方发现乙方违反此条款，甲方有权立即解除本合同，不退还乙方已支付的费用。<br>
	    （4）乙方应限制在指定安装的机器上通过甲方提供的软件界面查询或提取数据，禁止通过第三方或乙方自己开发的插件或其它工具提取数据。<br>
	    （5）在使用过程中乙方接受并遵守甲方软件系统的数据下载量限制条件，甲方享有下载量限制条件的最终解释权。</li>
	  <li><strong>权利：</strong>甲方声明并保证本合同约定的软件及数据服务的任何资格及所有权益均为甲方或其供应者/提供方的专有财产。</li>
	</ol>
	
	<h3>服务</h3>
	<ol>
	  <li><strong>服务履行：</strong>甲方承诺在本合同约定期限内，优质、高效地履行本合同所规定的服务。</li>
	  </ol>
	<h3>配合</h3>
	  <ol>
	  <li>甲方应为乙方提供相关软件产品及相应的技术文档，有责任对乙方相关人员进行管理、操作、使用及技术培训。</li>
	  <li>乙方应按甲方要求提供合同所约定的软件产品所需的硬件设备及硬件环境，并有责任为甲方提供便利的工作条件。</li>
	  <li>乙方有责任为甲方的实施工作进行内部各部门、各营业部的协调，调动相关资源，配合甲方按进度完成项目实施。</li>
	  <li>甲方在对乙方的服务实施工作中如需要与乙方内部网络环境或软件有关系的第三方进行沟通，乙方有责任联系、协调。</li>
	  <li>甲方应不定期对软件产品进行自动升级，因乙方网络设置等原因导致升级不成功而出现的软件故障，由乙方负责解决。</li>
	  </ol>
	  <h3>安装、培训与其他服务</h3>
	  <ol>
	    <li>
	      <strong>安装：</strong>软件应由甲方为乙方进行安装。甲方的安装人员应经过培训，至少能够达到软件当前版本的安装资格要求。安装时应将对乙方正常经营活动所造成的影响降至最低限度，保持现场安全、清洁、有序。完成安装后，甲方应使现场保持清洁，不留下安装完成后不再需要的任何甲方的材料、工具及因安装所产生的垃圾和废物。
	    </li>
	    <li>
	      <strong>培训：</strong>有关软件操作的培训在软件安装之后由甲方向乙方提供，具体时间由甲乙双方另行协商确定。
	    </li>
	    <li>
	      <strong>其它服务：</strong>除在此描述的服务之外，甲方还可以根据乙方的要求并在甲方同意的条件下，向乙方提供其它服务。
	    </li>
	  </ol>
	
	<h3>其它保证和责任范围</h3>
	<ol>
	  <li><strong>软件保证：</strong>甲方声明并保证整个软件均符合其技术规范，如果在本合同约定期限内软件有故障，甲方应在收到乙方通知后24个小时内采取适当方式处理。对于非因乙方原因导致的服务中断，甲方将按服务中断时间为乙方免费顺延相同时间的使用期限。</li>
	  <li><strong>遵循法律：</strong>甲方保证，在软件及服务授权许可合同约定期限内，均符合所有可适用的法律、法规、规范性文件的要求。</li>
	  <li><strong>询问帮助：</strong>在本合同约定期限内，甲方提供及时响应的服务，甲方应在收到乙方的电话询问或请求服务时为乙方提供帮助，答复有关软件的问题；或向专家咨询以获得解决故障的协助；或尽力找出一个临时性的故障解决方案或应急的代替方法。</li>
	  <li><strong>数据传输：</strong>甲方尽最大诚信和努力收集及传送数据，甲方不对收集数据的真实性及传输过程中发生的传送错误承担除更正以外的法律责任，甲方不承担因数据错误或者传送错误造成乙方及乙方客户业务所受的直接利益和期待利益损失。</li>
	  <li><strong>除外责任：</strong>除上述明示的保证之外，甲方没有明示或暗示同意任何其它保证，包括但不限于甲方提供给乙方的所有信息和数据仅供乙方及乙方客户参考，甲方不承担乙方或乙方客户由此而导致的任何责任，乙方有责任知会其所有使用者。</li>
	</ol>
	
	<h3>机密信息</h3>
	<ol>
	  <li><strong>信息获取及保护：</strong>在本合同约定期限内，甲方和乙方均可能知晓对方的机密信息（包括但不限于本合同及附件、公司计划、运营活动、财务信息、技术信息、经营信息）。除法律规定及合同另有特别约定外，未经信息提供方书面同意，双方当事人及双方的管理人员、雇员及代理商，都应严格保守对方的机密信息，并采取必要措施以防止机密信息未经授权即被泄露、复制或使用。</li>
	  <li><strong>归还：</strong>收到机密信息的一方在收到披露方的请求后，应立即将占有或控制（如有）的所有披露方机密信息归还给披露方，如果本合同根据规定被解除或终止，则任何一方须自行归还、销毁或删除从对方获取的信息、文件和软件等载体。</li>
	  <li><strong>保密：</strong>双方的保密义务不因本合同的解除、终止及无效而免除。</li>
	  <li><strong>例外：</strong>为履行本合同起见，以下信息不被视为机密信息：在对方收到时已为公众所知的信息；从其它渠道合法获得的信息；遵照有司法管辖权的法院或者其他监管机构的要求必须告知的信息；披露方放弃保密性的信息。</li>
	</ol>
	
	<h3>版权</h3>
	<ol>
	  <li>甲方对合同涉及的软件产品及相关文档、信息拥有独立版权。乙方不得转让/许可第三方使用或者作合同目的以外的使用。</li>
	  <li>乙方不得自行复制、仿制甲方相关软件产品。乙方不得自行修改软件。乙方未经许可自行复制、仿制或修改的，由此产生的一切使用中的责任均由乙方承担。</li>
	</ol>
	
	<h3>终止</h3>
	<ol>
	  <li>除以上所述的终止权外，如果任何一方违背了本合同包含或引用的任何重要陈述、担保、合同或义务，若守约方书面通知对方此类严重违约，且违约方在收到此通知后未能在30天内纠正违约事实，则守约方可以提前通知对方终止本合同。本合同自守约方发出该通知之日即行终止，在此情况下，守约方无需承担任何违约或赔偿责任。</li>
	</ol>
	
	<h3>违约责任及争议解决</h3>
	<ol>
	  <li>除本合同特别约定之外，任何一方违反本合同约定的，均应根据相关法律法规向守约方承担违约责任。</li>
	  <li>因本合同产生或与此有关的任何争议应首先通过协商解决。如该等争议发生后30日内双方通过友好协商未能解决该等争议，双方同意将该等争议提交有管辖权的人民法院进行解决。</li>
	  <li>因乙方原因导致本合同被提前解除，甲方将不退还乙方已经支付的服务费用。</li>
	  <li>甲方于本合同项下所应承担的违约责任及过错责任（包括但不限于：违约金、赔偿金、实际损失等），累计不得超过本合同标的金额。</li>
	</ol>
	
	 <h3>其他事项</h3>
	  <ol>
	    <li><strong>通知：</strong>如果通知以书面形式被投递到本合同签字页上所注明的地址，根据本合同，即被视为送达到对方。该地址如有变动，各方应书面形式通知对方。</li>
	    <li><strong>标题：</strong>本合同中的所有标题仅作引用之用，且其中包含的词语不得以任何形式被解释、修改、放大或帮助对本合同的条款进行说明、解释或阐明。</li>
	    <li><strong>可分割性：</strong>如果本合同的任何条件或条款被有司法管辖权的法院以任何程度禁止或不能执行，合同的其余部分将不受影响，每一条款在法律许可的最大范围内均有效。</li>
	    <li><strong>修改：</strong>除非双方的法定代表人或授权签字人签字并加盖公章，任何对本合同的修改或修正以及对合同中任何条款的放弃均被视为无效。</li>
	    <li><strong>授权：</strong>甲方和乙方均有全部权利签订并履行本合同。代表双方签订本合同的代表经适当授权，有权签订本合同。</li>
	    <li><strong>独立关系：</strong>本合同包含的任何内容均不构成甲方和乙方之间形成合资关系、伙伴关系或者雇佣关系的暗示。任何一方均没有任何权利、特权给对方形成任何义务，不管是明示的还是暗示的，除非本合同另有规定或者双方根据本合同的条款同意。</li>
	    <li><strong>不可抗力：</strong>双方均不对因各方合理控制以外的事件而引起的履行义务的延迟或不能履行义务承担责任。此类事件应包括但不限于罢工、暴乱、战争、流行病、公共卫生事件、政府行为、火灾、停电、核事故、地震、异常气候、突发性网络故障、黑客攻击、软件病毒或其它灾难，无论是否与上述事项类似。</li>
	  </ol>
	  <h3>继续有效</h3>
	  <ol>
	  <li>本合同所包含的、双方认为其有效时间比本合同期限更长的条件、条款及保证，应在履行完本合同、取消或终止本合同之后继续生效。</li>
	  </ol>
	  <h3>份数</h3>
	  <ol>
	    <li>本协议以数据电文的形式体现，不提供纸质协议，乙方本人点击签署合同即生效。本协议保存在甲方指定位置，甲乙双方认可该形式的协议效力及本协议内容。</li>
	  </ol>
	  <p>（以下无正文）</p>
	  <h3>甲方：北京未来级数科技有限公司</h3>
	  <p>地址：北京市西城区茶马北街1号院1号楼10层2单元1121</p>
	  <h3>乙方：用户</h3>
	</div>`,
};
